import http from "./httpService";
const apiEndpoint = "/Extinguisher";
const url = "https://wms.advanceagro.net/ws2/api";
 const ApiUrl = "https://api-mobileapp.advanceagro.net";

// const ApiUrl = "http://127.0.0.1:3001";
// const ApiUrl = "http://10.29.15.222:3001";
export async function downLoadExcel(
  ReportCode,
  year,
  month,
  locationID = 0,
  itemid = 0,
  groupid = 0,CheckID=""
) {
  return http.get(
    
      ApiUrl+"/download/toexcelfastcheck?ReportCode=" +
      ReportCode +
      "&year=" +
      year +
      "&month=" +
      month +
      "&locationID=" +
      locationID +
      "&itemid=" +
      itemid +
      "&groupid=" +
      groupid,+
      "&CheckID=" +
      CheckID,
    { responseType: "blob" }
  );
}
export async function toexcelreportcheck(
  year,
  month,
  locationID = 0,
  areaid=0,equipmentid=0,statusid=0
  
) {
  return http.get( 
      ApiUrl+"/download/toexcelreportcheck?year=" + year +
      "&month=" +
      month +
      "&locationid=" +
      locationID +
      "&areaid=" +
      areaid +
      "&equipmentid=" +
      equipmentid  +
      "&statusid=" +
      statusid ,
    { responseType: "blob" }
  );
}
export async function getreportcheck(
  year,
  month,
  locationID = 0,
  areaid=0,equipmentid=0,pageSize = 30, pageNumber=1,statusid=0
  
) {
  return http.get(
      ApiUrl+"/fastcheck/getreportcheck?year=" + year +
      "&month=" +
      month +
      "&locationid=" +
      locationID +
      "&areaid=" +
      areaid +
      "&equipmentid=" +
      equipmentid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber + "&statusid=" + statusid
    // { responseType: "blob" }
  );
}
export async function getPrivilege() {
  return http.get(apiEndpoint + "/getPrivilege");
}//getArea


export async function getArealist() {
  return http.get(apiEndpoint + "/getarealist");
}
export async function activity(doc) {
  return http.post(apiEndpoint + "/activity",doc);
}

export async function saveItem(doc) {
  return http.post(apiEndpoint + "/AddItem", doc);
}
export async function saveGroup(doc) {
  return http.post(apiEndpoint + "/AddGroup", doc);
}
export async function getBU() {
  return http.get(apiEndpoint + "/getBU");
}
export async function GetYear() {
  return http.get(apiEndpoint + "/GetYear");
}
export async function getLocation() {
  return http.get(apiEndpoint + "/getLocation");
}
export async function getAreaSelect() {
  return http.get(apiEndpoint + "/getAreaSelect");
}
export async function getAreaZoneSelect(location=0) {
    return http.get(apiEndpoint + "/getAreaZoneSelect?location="+location);
}
export async function getAreaDetailSelect(areaid=0) {
  return http.get(apiEndpoint + "/getAreaDetailSelect?areaid="+areaid);
}
export async function getEquipmentSelect() {
  return http.get(apiEndpoint + "/getEquipmentSelect");
}
export async function getArea() {
  return http.get(apiEndpoint + "/getArea");
}
export async function getEquipment() {
  return http.get(apiEndpoint + "/getEquipment");
}

export async function getProductgroup() {
  return http.get(apiEndpoint + "/ProductGroup");
}

export async function getItems(areaid = 0, groupid = 0) {
  return http.get(
    apiEndpoint + "/getItembyGroup?locationid=" + areaid + "&groupid=" + groupid
  );
}
export async function getgroupequipment(year, month, groupname = "") {
  return http.get(
    apiEndpoint +
      "/groupequipment?year=" +
      year +
      "&month=" +
      month +
      "&locationid=" +
      groupname
  );
}
export async function getquipmentDetail(
  year,
  month,
  groupname = "",
  itemid = ""
) {
  return http.get(
    apiEndpoint +
      "//groupequipmentid?year=" +
      year +
      "&month=" +
      month +
      "&locationname=" +
      groupname +
      "&itemname=" +
      itemid
  );
}

export async function getAccountlist(
  name = "0",
  buid = "0",
  pageSize = 1000,
  pageNumber = 1
) {
  return http.get(
    apiEndpoint +
      "/getUser?name=" +
      name +
      "&buid=" +
      buid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}
export async function getItemlist(
  name = "",
  groupid = "0",
  areaid = "0",
  areazoneid = "0",
  detailid= "",
  buid = "",
  pageSize = 1000,
  pageNumber = 1,
  status = false
) {
 const req = apiEndpoint +
      "/getItemList?name=" +
      name +
      "&groupid=" +
      groupid +
      "&locationid=" +
      areaid +
      "&buid=" +
      buid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&disable=" +
      status +
      "&areaid=" +
      areazoneid +
      "&detailid=" +
      detailid ;
      // console.log(req);
  return http.get(req);
}
export async function getGrouplist(
  name = "",
  pageSize = 1000,
  pageNumber = 1,
  status = false
) {
  // console.log('status=',name);
  return http.get(
    apiEndpoint +
      "/getProductgroup?name=" +
      name +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&disable=" +
      status
  );
}
export async function getCompareBU(year = "", month = 0) {
  return http.get(
    apiEndpoint + "/CompareByBU?year=" + year + "&month=" + month
  );
}
export async function getUserAll() {
  return http.get(apiEndpoint + "/getUserAll");
}

export async function GetLocationAll() {
  return http.get(apiEndpoint + "/GetLocationAll");
}
export async function getSumaryByBU(year = "", month = 0, id = 1) {
  return http.get(
    apiEndpoint +
      "/GetSumaryByBU?year=" +
      year +
      "&month=" +
      month +
      "&id=" +
      id
  );
}
export async function ReportData(
  reportcode,
  year = "",
  month = 0,
  id = 0,
  empid = "",
  groupid = 0,
  itemid = 0,
  pageSize = 30,
  pageNumber=1
) {
  return http.get(
    apiEndpoint +
      "/ReportData?ReportCode=" +
      reportcode +
      "&year=" +
      year +
      "&month=" +
      month +
      "&locationID=" +
      id +
      "&CheckID=" +
      empid +
      "&groupid=" +
      groupid +
      "&itemid=" +
      itemid +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}

export async function getReportgroup() {
  return http.get(apiEndpoint + "/ReportList");
}

export async function getItem(id) {
  return http.get(apiEndpoint + "/GetItemData?ItemCode=" + id);
}
export async function getEmployee(
  search = "",
  pageSize = 1000,
  pageNumber = 1
) {
  // console.log(search);
  return http.get(
    url +
      "/face/GetUserInfo?search=" +
      search +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber
  );
}

export async function getsearchuser(
  search = "",
  site = 0,
  pageSize = 1000,
  pageNumber = 1,
  BUID = 0,
  DIP = "",
  comID = 0
) {
  return http.get(
    url +
      "/face/GetTotalUserInfor?search=" +
      search +
      "&site=" +
      site +
      "&pageSize=" +
      pageSize +
      "&pageNumber=" +
      pageNumber +
      "&BUID=" +
      BUID +
      "&ComID=" +
      comID +
      "&department=" +
      DIP
  );
}
export async function getAccount(
  name = "",
  pageNumber = 1
) {

  return http.get(apiEndpoint +"/getAccount?name=" +
      name +
     "&pageNumber=" +
      pageNumber
  );
}
export async function savedatauser(doc) {

  return http.post(ApiUrl +"/fastcheck/saveuser",doc);
}
export default {
  getPrivilege,
  getLocation,
  getAreaSelect,
  getAreaZoneSelect,
  getAreaDetailSelect,
  getEquipmentSelect,
  getArea,
  getBU,
  getEquipment,
  getItemlist,
  saveItem,
  getCompareBU,
  getGrouplist,
  saveGroup,
  GetYear,
  getSumaryByBU,
  getAccountlist,
  getReportgroup,
  ReportData,
  getItem,
  getUserAll,
  GetLocationAll,
  getProductgroup,
  getItems,
  getgroupequipment,
  getquipmentDetail,
  getsearchuser,
  downLoadExcel,
  getAccount,
  savedatauser,getreportcheck
};
